module.exports = {
	"id": "SH",
	"name": "Saint Helena",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 3.3345,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": null,
			"42": null,
			"43": null,
			"44": null,
			"45": 2.496,
			"46": null,
			"47": null,
			"48": 1.66725,
			"49": null,
			"50": null,
			"51": 0.82875,
			"52": 4.16325,
			"53": 24.999,
			"54": 14.9955,
			"55": null,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.82875,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": null,
			"42": null,
			"43": null,
			"44": null,
			"45": null,
			"46": null,
			"47": 3.3345,
			"48": 17.50125,
			"49": 7.49775,
			"50": 1.66725,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": null,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"3.1": null,
			"3.2": null,
			"5.1": null,
			"6.1": null,
			"7.1": null,
			"9.1": null
		},
		"ios_saf": {
			"8": 0,
			"10": 0,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0,
			"8.1-8.4": 0,
			"9.0-9.2": 0,
			"9.3": 0
		},
		"android": {
			"3": 0,
			"4": 0,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0,
			"4.1": 0,
			"4.2-4.3": 0,
			"4.4": 0,
			"4.4.3-4.4.4": 0
		},
		"ie": {
			"6": null,
			"7": null,
			"8": null,
			"9": 1.66725,
			"10": null,
			"11": 10.0035,
			"5.5": null
		},
		"op_mob": {
			"0": 0,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0
		},
		"edge": {
			"12": null,
			"13": null,
			"14": null
		},
		"ie_mob": {
			"10": 0,
			"11": 0
		},
		"bb": {
			"7": 0,
			"10": null
		},
		"samsung": {
			"0": null
		},
		"and_uc": {
			"0": null
		},
		"op_mini": {
			"0": 0
		},
		"and_chr": {
			"0": 0.83325
		},
		"and_ff": {
			"0": 1.66675
		}
	},
	"total": 97.4845
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SH.json
 ** module id = 643
 ** module chunks = 0
 **/